import Domen from '../../../stores/Domen';


export const getColumnInfo = async (dataset_id, setMasscheca, setActivedataset, setUpdateselect) => {
  try {
    const token = localStorage.getItem("token");
    localStorage.setItem("countactivetime", Date.now());

    const response = await fetch(`${Domen.url}portraits/columns_info?dataset_id=${dataset_id}`, {
      method: "GET",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200) {
      const data = await response.json();
      const t = data.map((n) => {
        const categories = n.type === "categorical"
          ? n.categories.map((q) => ({ check: false, name: q }))
          : [];

        return {
          check: false,
          title: n.column_name,
          type: n.type,
          categories,
        };
      });

      setMasscheca(t);
      setActivedataset(t);
      setUpdateselect(false);
    } else {
      // Обробка помилки або інше перенаправлення
    }
  } catch (error) {
    console.error("getColumnInfo error:", error);
  }
};
